import React from "react"
import { Link, graphql } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../../components/layout"
import PostContentHeader from "../../components/post-content-header"
import PostMainImage from "../../components/post-main-image"
import CategoryDateShare from "../../components/category-date-share"
import Seo from "../../components/seo"
import AuthorContent from "../../components/author-content"

import _ from 'lodash'
import ogImage from "../../images/posts/12/thumb-landscape.jpg"

const Post12 = ({ data: { allCategoryJson, postsJson }, location }) => { 
  
  const category = _.find(allCategoryJson.edges, (edge) => {
    return edge.node.categoryId === postsJson.categoryId
  }).node

return (
<Layout>
  <Seo title={postsJson.title} description={postsJson.description} ogImage={ogImage} />
  <div className="posts">
    <PostContentHeader categoryName={category.nameJA} postTitle={postsJson.title} location={location} />
    <section id="pickup-article">
      <PostMainImage post={postsJson} />
      <div className="description wrapper text-two-cloumn">
        <CategoryDateShare category={category} post={postsJson} />
        <div className="title">
          <h1>{postsJson.title}</h1>
          <p>
          近年、様々な芸能人やモデルなどのファッショニスタがこぞって愛用しているハイブランド「BALENCIAGA(バレンシアガ)」。シンプルで気取らないデザインのバッグは、普段のコーデに合わせるだけで上級者のオシャレを演出できるとインスタグラムやファッションサイトでも注目が集まっています。今回はそんなバレンシアガの人気バッグ9選をご紹介します！
          </p>
        </div>
      </div>
    </section>
    <div className="wrapper">
      <section className="bag-content">
        <div className="text-max-width">
          <h2>カバ</h2>
          <p>数多くの芸能人・モデルが愛用したことで人気に火がつき、それ以来ブランドの顔となった「カバ」。デザインは定番のキャンバス地からレザータイプまで幅広く、容量も大きいのでマザーバッグとしてもおすすめ。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/12/1.jpg" alt="" />
          <div className="text-center">ネイビーカバ M /43x33x21cm(幅x高さxマチ)</div>         
        </figure>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/2.jpg" alt="" />
            <div className="text-center">ネイビーカバ S /30x23x17cm(幅x高さxマチ)</div>         
          </figure>       
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/3.jpg" alt="" />
            <div className="text-center">ネイビーカバ XS /24x20x7cm(幅x高さxマチ)</div>         
          </figure>
        </div>
        <div className="text-max-width">
          <h2>ヴィル</h2>
          <p>小ぶりなサイズ感にステンシルペイントのロゴが映える「ヴィル」。トップハンドルタイプはM/S/XXSのサイズ展開です。カラーバリエーションやパターンも豊富なので、コーデに合わせてお好みの１点を選んでみては？</p>
        </div>     
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/4.jpg" alt="" />
            <div className="text-center">ヴィル トップハンドル S /26x21x12cm(幅x高さxマチ)</div>            
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/5.jpg" alt="" />
            <div className="text-center">ヴィル トップハンドル XXS /18x15x8cm(幅x高さxマチ)</div>              
          </figure>          
        </div>                     
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/6.jpg" alt="" />
            <div className="text-center">ヴィル デイバッグ S /18x12x4cm(幅x高さxマチ)</div>             
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/7.jpg" alt="" />
            <div className="text-center">ヴィル デイバッグ XS /18x12x4cm(幅x高さxマチ)</div>             
          </figure>
        </div>              
        <div className="text-max-width">
          <h2>アワーグラス</h2>
          <p>2019年秋冬コレクションで登場以来、インパクトのあるデザインで根強い人気を獲得したバッグ。アワーグラス（砂時計）の名の通り、底部とフラップの美しいカーブが特徴です。意外にもマチ幅が広く、収納力も抜群。かっちりしているので型崩れの心配もなく、美しさと機能性を兼ね備えた１点。</p>
        </div>        
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/8.jpg" alt="" />
            <div className="text-center">アワーグラス S /22x13x9cm(幅x高さxマチ)</div>              
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/9.jpg" alt="" />
            <div className="text-center">アワーグラス XS /19x11x7cm(幅x高さxマチ)</div>
          </figure>
        </div>       
        <figure className="img-small">
          <StaticImage src="../../images/posts/12/10.jpg" alt="" />
        </figure>        
        <Link to="https://laxus.co/app/pc/bags/balenciaga" className="view-all-button">
          バレンシアガのバッグを見る
        </Link>         
        <div className="text-max-width">
          <h2>トライアングルダッフル</h2>
          <p>スキーブーツバッグから着想したユニークなフォルムが魅力の「トライアングル」。スポーティーで構築的なデザインは、特にカジュアルコーデと相性抜群！ワンポイントアイテムとして映えること間違いなし。</p>
        </div>
        <figure className="img-small">
          <StaticImage src="../../images/posts/12/11.jpg" alt="" />
          <div className="text-center">トライアングルダッフル S /23x23x9cm(幅x高さxマチ)</div>           
        </figure>        
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/12.jpg" alt="" />              
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/13.jpg" alt="" />
          </figure>          
        </div>
        <div className="text-center">トライアングルダッフル XS /20x20x6cm(幅x高さxマチ)</div>        
        <div className="text-max-width">
          <h2>ショッピング/ショッピングフォンホルダー</h2>
          <p>世界的なロングセラーを記録しているバレンシアガの大ヒットバッグ「ショッピング」ライン。XXSサイズでも、500mlのペットボトルや財布が充分に入ります。シリーズ最小の「フォンフォルダー」は名前の通りスマートフォンがぴったりと入るコンパクトなサイズ感。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/14.jpg" alt="" />
            <div className="text-center">ショッピング M /30x42x10cm(幅x高さxマチ)</div> 
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/15.jpg" alt="" />
          <div className="text-center">ショッピング S /28x26x10cm(幅x高さxマチ)</div>
          </figure>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/16.jpg" alt="" />
            <div className="text-center">ショッピング XXS /19x20x9cm(幅x高さxマチ)</div>            
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/17.jpg" alt="" />
            <div className="text-center">ショッピング フォンホルダー /12x18x5cm(幅x高さxマチ)</div>  
          </figure>
        </div>       
        <div className="text-max-width">
          <h2>エクスプローラー</h2>
          <p>「エクスプローラー」は、メンズからも注目を集めているベルトバッグ。ウエストポーチタイプのものは、長財布とスマートフォンを楽に収納できるサイズ感。パーカーやジーンズといったカジュアルなアイテムと相性が良いので、普段のコーデに気軽に取り入れられます。</p>
        </div>
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/18.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/19.jpg" alt="" />
          </figure>          
        </div>
        <div className="text-center">エクスプローラー ベルトバッグ /20x18x6cm(幅x高さxマチ)</div>                        
        <figure className="img-small">
          <StaticImage src="../../images/posts/12/20.jpg" alt="" />
        </figure>                   
        <div className="text-max-width">
          <h2>エブリデイトート</h2>
          <p>カーフレザーで仕立てたミニマルなトートバッグ「エブリデイトート」。フラットでごくシンプルなデザインが洗練された印象を演出します。取り外し可能なストラップが付属しているため、ショルダーと手持ちの2WAYで持つことができます。</p>
        </div>         
        <figure className="img-small">
          <StaticImage src="../../images/posts/12/21.jpg" alt="" />
          <div className="text-center">エブリデイトート /30x31x15cm(幅x高さxマチ)</div>         
        </figure>
        <div className="img-two-cloumn">          
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/22.jpg" alt="" />
            <div className="text-center">エブリデイトート XS /25x27x12cm(幅x高さxマチ)</div>         
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/23.jpg" alt="" />
            <div className="text-center">エブリデイトート XXS /19x21x9cm(幅x高さxマチ)</div>         
          </figure>          
        </div>
        <Link to="https://laxus.co/app/pc/bags/balenciaga" className="view-all-button">
          バレンシアガのバッグを見る
        </Link>          
        <div className="text-max-width">
          <h2>ドローストリングバケットバッグ</h2>
          <p>女性らしい丸みのあるフォルムの「ドローストリングバケットバッグ」。付属のストラップを付けてクロスボディーとして、ストラップを外してワンハンドルバッグとして使用するなど、カジュアルからフォーマルまで幅広いスタイリングを楽しめるのがポイント。</p>
        </div> 
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/24.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/25.jpg" alt="" />
          </figure>
        </div>
        <div className="text-center">ドローストリングバケットバッグ XS /14x18x14cm(幅x高さxマチ)</div>                    
        <div className="text-max-width">
          <h2>ネオクラシック</h2>
          <p>一斉を風靡した名作バッグ「クラシック」の誕生から20年を記念し、2020年新たにデザインをアップデートしたことで話題となった「ネオクラシック」。サイズはL/S/ミニ/ナノの4展開。A4サイズも収納できるL/Sサイズは旅行用・ビジネスバッグとしても大活躍間違いなし。ミニ/ナノはミニサイズだからこその精巧さが際立つ、アクセサリー感覚で取り入れたいアイテム。</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/12/26.jpg" alt="" />
        </figure>
        <div className="text-center">ネオクラシック M /44x25x17cm(幅x高さxマチ)</div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/27.jpg" alt="" />
            <div className="text-center">ネオクラシック ミニ /24x14x9cm(幅x高さxマチ)</div>   
          </figure>             
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/28.jpg" alt="" />
            <div className="text-center">ネオクラシック ナノ /18x11x7cm(幅x高さxマチ)</div>   
          </figure>         
        </div>
        <div className="text-max-width">
          <h2>ネイビー ポシェット</h2>
          <p>「ネイビー ポシェット」は、キャンバス地や中央に入ったロゴが特徴的な「カバ」のデザインを受け継いでおり、カジュアルコーデと相性抜群。財布・スマホなどの小物が収納可能なコンパクトなサイズ感は、デイリーに使いやすくちょっとしたお出かけにぴったり。</p>
        </div>
        <figure className="img-small">
            <StaticImage src="../../images/posts/12/29.jpg" alt="" />
        </figure>
        <div className="text-center">ネイビー ポシェット S /22x16x5cm(幅x高さxマチ)</div>         
        <div className="img-two-cloumn">
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/30.jpg" alt="" />
          </figure>
          <figure className="img-small">
            <StaticImage src="../../images/posts/12/31.jpg" alt="" />
          </figure>
        </div>
        <div className="text-center">ネイビー ポシェット M /26x19x7cm(幅x高さxマチ)</div>                     
        <div className="text-two-cloumn">
          <h2>まとめ</h2>
          <p>モードで機能的なバレンシアガのバッグ。ちょっとしたお出かけ用としても、マザーバッグとしても幅広く使え、デイリーに活躍してくれること間違いなし。ぜひ一度、実際にバッグを手に取ってみてはいかがでしょうか？</p>
        </div>                                       
        <Link to="https://laxus.co/app/pc/bags/balenciaga" className="view-all-button">
          バレンシアガのバッグを見る
        </Link>                                                   
      </section>
      <AuthorContent authorId={postsJson.authorId} />
    </div>
  </div>
</Layout>
)}

export default Post12

export const pageQuery = graphql`
  query {
    postsJson(postId: {eq: 12}) {
      id
      title
      description
      postId
      postedAt
      description
      categoryId
      authorId
      thumbnailSquare {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      thumbnailLandscape {
        src {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
    }
    allCategoryJson(sort: {fields: sortOrder}) {
      edges {
        node {
          id
          categoryId
          slug
          nameJA
          nameEN
          description
        }
      }
    }
  }
`
